import AuthMixin from '@/components/mixins/auth-mixin'
import MenuItems from '@/components/common/menu-items/menu-items-tmpl'
import { useMixpanel } from '@base-shared/composables/use-mixpanel'

export default {
  name: 'menuComp',
  inject: [
    '$currentUser',
    '$utils'
  ],
  components: {
    menuItemsComp: MenuItems
  },
  props: {
    data: {
      default () { return 'object' }
    }
  },
  watch: {},
  mixins: [AuthMixin],
  data () {
    return {
      productName: CONFIG.PRODUCT_NAME
    }
  },
  mounted () {
    useMixpanel().track('Menu')
    this.isAuthenticated()
  }
}
